export var OrganizationRole;
(function (OrganizationRole) {
    OrganizationRole["OWNER"] = "owner";
    OrganizationRole["ADMIN"] = "admin";
    OrganizationRole["MEMBER"] = "member";
})(OrganizationRole || (OrganizationRole = {}));
//# sourceMappingURL=organization-role.enum.js.map